export const AT_ERROR_SET = 'SIGNIN_ERROR_SET';
export const AT_IS_LOADING_SET = 'SIGNIN_IS_LOADING_SET';
export const AT_IS_SHOW_SET = 'SIGNIN_IS_SHOW_SET';
export const AT_RESET = 'SIGNIN_RESET';
